module.exports = __webpack_public_path__ + "img/Swamp-Jumpstart-MtG-Art.b9a8db3a.jpg";